import { 
    apiRequest,
    AwardUpdate
} from '../../../../../services/adapters/kepegawaian/penghargaanService'

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest('post', AwardUpdate, {
            body: query
        }, true)
    }
 
}

export default UpdateRepository